/**
 * 聚合弹窗 EdgenModal 外壳配置（⑥⑦⑧ 共用，保证 PC 上等宽）。
 *
 * 尺寸约定（对齐 `diagnosisUnlockModalShell`）：
 * - H5：`--modal-width: 100%`、`--modal-height: 100dvh` → 全屏
 * - PC（md+）：宽 480px、高度由内容撑开、`max-height: 90dvh`、圆角 24px
 * - PC Step ⑥ Loading：步内固定 674px（见 `AggregatedOnboardingFlowContent`）
 *
 * 与同事独立 `openLoadingOnboardingModal`（PC 393px）及 ⑦⑧ 独立弹窗（PC 600px）分离。
 */

/** PC 居中弹层宽度（px），三步一致。 */
export const AGGREGATED_ONBOARDING_MODAL_PC_MAX_WIDTH_PX = 480;

/** PC 弹窗最大高度（⑦⑧ 内容超出时壳层 + 步内滚动） */
export const AGGREGATED_ONBOARDING_MODAL_PC_MAX_HEIGHT = "90dvh";

/** PC Step ⑥ Loading 固定高度 */
export const AGGREGATED_ONBOARDING_MODAL_PC_LOADING_HEIGHT_PX = 674;

/** 传入 `EdgenModalCreateAble.call` 的静态 props（勿在运行时改 className，避免 Uno 扫描不到）。 */
export const AGGREGATED_ONBOARDING_MODAL_PROPS = {
  className:
    "[--modal-radius:0px] md:[--modal-radius:24px] [--modal-width:100%] [--modal-height:100dvh] [--modal-min-height:0px] [--modal-max-height:none] md:[--modal-width:480px] md:[--modal-height:auto] md:[--modal-min-height:0px] md:[--modal-max-height:90dvh]",
  contentStyle: {
    borderRadius: "var(--modal-radius)",
    width: "var(--modal-width)",
    height: "var(--modal-height)",
    minHeight: "var(--modal-min-height)",
    maxHeight: "var(--modal-max-height)",
    overflow: "hidden" as const,
    padding: 0,
  },
  styles: {
    body: {
      height: "var(--modal-height)",
      minHeight: "var(--modal-min-height)",
      maxHeight: "var(--modal-max-height)",
    },
  },
  containerStyle: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    minHeight: 0,
    overflow: "hidden" as const,
  },
  titleStyle: {
    minHeight: 0,
  },
  showClose: false,
  maskClosable: false,
  destroyOnClose: true,
} as const;
